<template>
    <div class="bax-section bax-select-patient-wrap">
        <div class="container bax-wide">
            <div class="bax-bg bax-bg-foot-link bax-create-patient">
    <div>
        <section class="csvUploadSection">


            <div v-if="all_fields_matched" class="action-buttons">
                <p>
                We have matched all fields in your import file with our data. Please proceed to the final review before we create your orders.
                </p><BR />
                <input type="button" value="Refresh" class="bax-btn bax-btn-blue ml-auto mt-3 mt-md-0"  @click="initstuff">
                <input type="button" value="Review Orders" class="bax-btn bax-btn-blue ml-auto mt-3 mt-md-0"  @click="$emit('fields_matched');$emit('waiting_set', 'Searching for Presentations');">
            </div>
            <div v-else>
                <p>
                    We found some keywords in your upload that we didn't understand. Those keywords are listed on the left. Please match them with keywords on the right. Once all your keywords are matched then we can import your file.
                </p>
                <p>
                </p>
                <table v-if="missing_fields" class="match-table">
                    <template v-for="(missing_field, field_name, row_index) in missing_fields">
                        <template  v-if="(drugs_matched || field_name == 'drug_name')">
                        <tr v-bind:key="row_index + '_row'">
                            <td> <strong>{{ field_name }}</strong> </td>
                            <td> Matches</td>
                        </tr>
                            <template v-for="(field_value, index) in missing_field">
                                <tr v-bind:key="row_index + '_row_' + index">
                                    <td> {{ field_value }}</td>
                                    <td>
                                        <v-autocomplete-select
                                                label="title"
                                                :dataField="field_name"
                                                v-model="matched_fields[field_name][index]"
                                                :options="getFieldList(field_name)"
                                        >
                                            class="drug-selector">
                                        </v-autocomplete-select>
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </template>
                    <tr>
                        <td></td>
                        <td>
                            <div class="action-buttons">
                                <input type="button" value="Refresh" class="bax-btn bax-btn-bordered-blue ml-auto mt-3 mt-md-0"  @click="initstuff">
                                <input type="button" value="Submit Matches" class="bax-btn bax-btn-blue ml-auto mt-3 mt-md-0"  @click="submitMatches">
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </section>
    </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CsvService from '@/core/api/csv/csv.service3';
    import DrugService from '@/core/api/drug/drug.service';

    import csvMixin from './csvMixin';

    export default {
        name: 'Stage4',
        mixins: [csvMixin],
        props: ['uploadCode'],
        data() {
            return {
                missing_fields: [],
                matched_fields: {
                    drug_name: {}, drug_dose_unit: {}, route: {}, container_type: {}, diluent: {}, infusion_time_unit: {}, ancillary: {},
                    },
                drugs: [],
                drugs_matched: false,
                all_fields_matched: false,
                ancilliaries: [],
                field_lists: [],
            };
        },
        async created() {
            this.initstuff();
        },
        methods: {
            async initstuff() {
                this.markedFilesProcess();
                const response = await DrugService.getAllDrugs();
                this.drugs = response.data;

                let firstItem = {
                    title: 'Skip row - For this and future imports',
                };
                this.drugs.unshift(firstItem);

                firstItem = {
                    title: 'Skip row - For this import',
                };
                this.drugs.unshift(firstItem);
                this.$watch('matched_fields', this.fieldsChangeWatcher, { deep: true });
            },
            markedFilesProcess() {
                this.$emit('waiting_set', 'Searching for substitutions');
//                this.matched_fields = {};
 //               this.matched_fields.matched_drug_name = {};
 //               this.matched_fields.matched_drug_name = {};
                delete this.missing_fields.progress_amount;
                const data = {
                    marked_rows: 1,
                    uploadCode: this.uploadCode,
                    missing_fields: this.missing_fields,
                };

                CsvService.processMarkedRows(data)
                    .then(async (res) => {
                        if (this.check_progress(res.data.progress_amount, res.data.progress_complete)) {
                            this.field_lists = res.data.field_lists;

                            if (this.missing_fields) {
                                Object.keys(this.missing_fields).forEach((fieldName) => {
                                    if (fieldName !== 'progress_amount') {
                                        this.matched_fields[fieldName] = {};
                                    }
                                });
                            }

                            this.ancilliaries = [];
                            Object.keys(this.field_lists.ancillary).forEach((componentID) => {
                                this.ancilliaries.push(this.field_lists.ancillary[componentID].genericName);
                            });

                            this.drugs_matched = !this.missing_fields.drug_name;
                            this.all_fields_matched = Object.keys(this.missing_fields).length === 0;
                            // this.$emit('file_loaded', uploadCode.data);
                            this.$emit('waiting_set', false);
                        } else {
                            if (res.data.missing_fields) {
                                this.missing_fields = res.data.missing_fields;
                            }
                            this.$emit('progress', res.data.progress_amount * 100);
                            this.markedFilesProcess();
                        }
                    });
            },
            fieldsChangeWatcher() {
                let firstMissingField = false;
                Object.keys(this.missing_fields).forEach((fieldName) => {
                    let foundAllValuesForThisField = true;
                    (this.missing_fields[fieldName]).forEach((valueName, valueIndex) => {
                        if (this.matched_fields[fieldName] && this.matched_fields[fieldName][valueIndex]) {
                            // we have found a matching value for this
                        } else {
                            foundAllValuesForThisField = false;
                        }
                    });
                    if (!foundAllValuesForThisField) {
                        if (!firstMissingField) {
                            firstMissingField = fieldName;
                        }
                    }
                });
            },
            getFieldList(fieldName) {
                let returnList = ['Skip row - For this import', 'Skip row - For this and future imports', 'Ignore this field'];
                switch (fieldName) {
                    case 'drug_name':
                    case 'drug2_name':
                            return this.drugs;
                    case 'drug_dose_unit':
                    case 'drug2_dose_unit':
                        returnList = returnList.concat(Object.values(this.field_lists.drug_dose_unit));
                        break;
                    case 'route':
                        returnList = returnList.concat(Object.values(this.field_lists.route));
                        break;
                    case 'container_type':
                        returnList = returnList.concat(Object.values(this.field_lists.container_type));
                        break;
                    case 'diluent':
                        returnList = returnList.concat(Object.values(this.field_lists.diluent));
                        break;
                    case 'infusion_time_unit':
                        returnList = returnList.concat(Object.values(this.field_lists.infusion_time_unit));
                        break;
                    case 'ancillary':
                        returnList = returnList.concat(this.ancilliaries);
                        break;
                    case 'ancillary2':
                        returnList = returnList.concat(this.ancilliaries);
                        break;
                    default:
                        return [];
                }

                return returnList;
            },
            submitMatches() {
                const data = {};
                data.matched_rows = true;
                data.missing_fields = this.missing_fields;

                data.matched_fields = this.matched_fields;
                data.uploadCode = this.uploadCode;

                CsvService.processMatchedRows(data)
                    .then(() => {
                        // this.$emit('file_loaded', uploadCode.data);
                        this.missing_fields = [];
                        this.$emit('progress', 0);
                        this.markedFilesProcess();
                    });
            },
        },
    };
</script>

